import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { TextareaItem, Button } from 'antd-mobile';
import { createForm } from 'rc-form';
import ImagePicker from '@components/ImagePicker/index'
import iconFaq from '@assets/img/suggest/icon_faq.png'
import iconMail from '@assets/img/suggest/icon_mail.png'
import { observer, inject } from 'mobx-react'
import * as styles from './styles/index.scss'
import intl from '@utils/intl'
class Suggest extends ComponentExt<any, any>{
    constructor(props) {
        super(props)
        this.state = { files: [] }
    }
    handleSubmit = () => {
        this.props.form.validateFields(async (err, value) => {
            if (!err) {
                try {
                    if (!value.suggestion) {
                        return this.$toast.fail(intl.formatMessage({ id: "suggest.toast" }))
                    }
                    let imageList = []
                    if (this.state.files.length > 0) {
                        const formData = new FormData()
                        this.state.files.map(item => {
                            formData.append('files', item.file)
                        })
                        imageList = await this.api.uploadEditorimg(formData)
                    }
                    await this.api.addQuestion({ questionDesc: value.suggestion, image1: JSON.stringify(imageList) })
                    this.$toast.success(intl.formatMessage({ id: "suggest.success" }))
                    this.goToPath('/global/submission')
                } catch (error) {
                }
            }
        })
    }
    getImageFiles = (files) => {
        this.setState({ files })
    }
    render() {
        const { getFieldProps } = this.props.form;
        return <div>
            <header className={styles.title}>{intl.formatMessage({ id: "suggest.title" })}</header>
            <div className={styles.content} >
                <TextareaItem
                    {...getFieldProps('suggestion')}
                    rows={6}
                    count={200}
                    placeholder={intl.formatMessage({ id: "suggest.suggestions" })}
                />
                <ImagePicker getImageFiles={this.getImageFiles} />
                <Button className={styles.subBtn} onClick={this.handleSubmit}>{intl.formatMessage({ id: "suggest.submit" })}</Button>
                <Button className={styles.SubmissionBtn} onClick={() => this.goToPath('/global/submission')}>{intl.formatMessage({ id: "suggest.submission" })}</Button>
                <div className={styles.footerContent}>
                    <p style={{ fontSize: '16px' }}>{intl.formatMessage({ id: "suggest.information" })}</p>
                    <div className={styles.valueTip} style={{ alignItems: 'center' }}>
                        <img src={iconFaq} />
                        <span onClick={() => this.goToPath('/global/faq')}>{intl.formatMessage({ id: "me.nav.FAQ" })}</span>
                    </div>
                    <div className={styles.valueTip}>
                        <img src={iconMail} />
                        <div>
                            <p>Service mailbox</p>
                            <p>service@lenovoconnect.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default createForm()(Suggest);